// import { RouteEnum } from '@shared/enum/route.enum'
import { RouteEnum } from '@shared/enum/route.enum';
import { removeBusListeners, removeEventListeners } from './event.listener.lib';
import { sessionManager } from '@shared/service/sessionManager/session-manager.class';
import { ReloadMethodEnum } from '@shared/enum/reload-method.enum';

/**
 * Reload page (with cache)
 */
export const simpleReload = () => {
  removeBusListeners();
  removeEventListeners();

  window.location.reload();
};

/**
 * Force reload page without cache
 */
export const fullReload = async (reloadMethod?: ReloadMethodEnum) => {
  removeBusListeners();
  removeEventListeners();

  if (reloadMethod == null || reloadMethod == ReloadMethodEnum.METHOD_1) {
    fullReloadMethod1()
  } else if (reloadMethod == ReloadMethodEnum.METHOD_2)  {
    await fullReloadMethod2()
  } 
};

const fullReloadMethod1 = () => {
  // window.location.href = window.location.href.replace(/#.*$/, `/${RouteEnum.HOME}`)
  window.location.href = window.location.href.replace(/#.*$/, '');
}

const fullReloadMethod2 = async () => {
  if (sessionManager.isOnline.value) {
    await fetch(`/${RouteEnum.HOME}`, {
      headers: {
        Pragma: 'no-cache',
        Expires: '-1',
        'Cache-Control': 'no-cache',
      },
    })
    window.location.href = `/${RouteEnum.HOME}`
  }
  
  // This is to ensure reload with url's having '#'
  window.location.reload()
}
